import { useEffect } from 'react';
import { useHistory } from 'quartz-routing/react-router';
import Raven from 'raven-js';
import { fetchMeetingsLinkInfo } from 'MeetingsAdmin/api/meetingsLinkAPI';
import { LoadingDots } from 'foundations-components/transitional/components/LoadingDots';
import { jsx as _jsx } from "react/jsx-runtime";
export default function DefaultLinkRedirect() {
  const history = useHistory();
  useEffect(() => {
    let cancelled = false;
    fetchMeetingsLinkInfo(null).then(links => {
      if (cancelled) return;
      const defaultLink = links.find(link => link.isDefaultLink);
      if (defaultLink) {
        history.replace(`/link/${defaultLink.id}`);
      } else {
        history.replace('/');
      }
    }).catch(error => {
      if (!cancelled) {
        Raven.captureException(error, {
          extra: {
            message: 'Failed to fetch default meeting link'
          }
        });
        history.replace('/');
      }
    });
    return () => {
      cancelled = true;
    };
  }, [history]);
  return /*#__PURE__*/_jsx(LoadingDots, {
    minHeight: 400
  });
}